"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGAVKey = exports.getGAPKey = exports.getGAMKey = exports.getGAKey = void 0;
exports.getMinorVersion = getMinorVersion;
var _semver = _interopRequireDefault(require("semver"));
function getMinorVersion(version) {
  try {
    return "".concat(_semver.default.major(version), ".").concat(_semver.default.minor(version));
  } catch (_unused) {
    return 'INVALID_SEMVER';
  }
}
var getAssetMetadata = function getAssetMetadata(source) {
  if ('asset' in source) {
    return source.asset;
  }
  if ('params' in source) {
    if ('asset' in source.params) {
      return source.params.asset;
    }
    return source.params;
  }
  return source;
};
var getGAKey = exports.getGAKey = function getGAKey(action) {
  var _getAssetMetadata = getAssetMetadata(action),
    groupId = _getAssetMetadata.groupId,
    assetId = _getAssetMetadata.assetId;
  return "".concat(groupId, "/").concat(assetId);
};
var getGAVKey = exports.getGAVKey = function getGAVKey(action) {
  var _getAssetMetadata2 = getAssetMetadata(action),
    groupId = _getAssetMetadata2.groupId,
    assetId = _getAssetMetadata2.assetId,
    version = _getAssetMetadata2.version;
  return "".concat(groupId, "/").concat(assetId, "/").concat(version);
};
var getGAMKey = exports.getGAMKey = function getGAMKey(action) {
  var assetMetadata = getAssetMetadata(action);
  if (assetMetadata.version) {
    return "".concat(assetMetadata.groupId, "/").concat(assetMetadata.assetId, "/").concat(getMinorVersion(assetMetadata.version));
  }
  return "".concat(assetMetadata.groupId, "/").concat(assetMetadata.assetId, "/").concat(assetMetadata.minorVersion);
};
var getGAPKey = exports.getGAPKey = function getGAPKey(action) {
  var _getAssetMetadata3 = getAssetMetadata(action),
    groupId = _getAssetMetadata3.groupId,
    assetId = _getAssetMetadata3.assetId,
    versionGroup = _getAssetMetadata3.versionGroup;
  return "".concat(groupId, "/").concat(assetId, "/").concat(versionGroup);
};
//# sourceMappingURL=assets.js.map